export default __webpack_public_path__ + "static/media/img2.bed9ba2f.png";